import React from 'react';

import { PrismicRichText } from 'types/prismicRichtext';
import { linkResolver } from 'utils/linkResolver';

import { asText, RichText } from 'components/rich-text/RichText';
import { List } from 'components/list/List';
import { ListItem } from 'components/list/ListItem';
import { ImageContainer } from './ImageContainer';
import { PrismicImage } from '../../types/prismicImage';
import { PrismicBodyListFields } from 'types/prismicSlices';

interface IListContainer {
  title: PrismicRichText;
  image?: PrismicImage;
  caption: PrismicRichText;
  display?: string;
  items: PrismicBodyListFields[];
  isColumnLayout: boolean;
}

export const ListContainer = ({ title, image, caption, isColumnLayout, items }: IListContainer) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <List
      title={title ? asText(title) : undefined}
      image={(image && <ImageContainer image={image} caption={caption} captionStyle="horizontal" imageOnly />) || undefined}
      isColumnLayout={isColumnLayout}
    >
      {items.map((item: PrismicBodyListFields, i: number) => (
        <ListItem key={i} text={<RichText>{item.text}</RichText>} link={linkResolver(item.link)} />
      ))}
    </List>
  );
};
